import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const OrderDetailsHeaderRow = styled.div({
	display: "flex",
	justifyContent: "space-between"
});

export const DetailsHeaderContent = styled.div({
	display: "flex",
	justifyContent: "space-between",
	div: {
		width: "33%"
	}
});

export const ReviewShippingDetails = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "16px"
}));

export const ReviewShippingDetailsRow = styled.div({
	display: "flex",
	gap: "24px",
	div: {
		flex: 1
	}
});

export const AccountBillToBox = styled(Box)(({ theme }) => ({
	border: theme.project.borders.presets.thinOutline,
	padding: "20px",
	width: "100%",
	display: "flex",
	flexDirection: "column",
	gap: "20px"
}));
